import { ThemeTokens, VARIANTS } from '../../types';

export const BRAND_PURPLE = '#1e0a3c';
export const ACCESSIBLE_BRAND_ORANGE = '#D1410C';
export const PRIMARY_BRAND_ORANGE = '#F05537';
export const GRAY_UI_2000 = '#EEEDF2';
export const WHITE = '#FFFFFF';
export const BLACK = '#000000';
export const TRANSPARENT = 'transparent';

export const defaultStyles: Record<ThemeTokens, any> = {
    background: {
        background: BRAND_PURPLE,
    },
    'overlay-gradient': {
        color: BLACK,
        background: BRAND_PURPLE,
    },
    ctaLink: {
        border: PRIMARY_BRAND_ORANGE,
        color: WHITE,
    },
    'card-ctaLink': {
        border: PRIMARY_BRAND_ORANGE,
        color: BRAND_PURPLE,
    },
    'card-text': {
        color: BRAND_PURPLE,
        underline: PRIMARY_BRAND_ORANGE,
    },
    text: {
        color: WHITE,
        underline: ACCESSIBLE_BRAND_ORANGE,
    },
    card: {
        background: WHITE,
    },
    'button-primary': {
        background: PRIMARY_BRAND_ORANGE,
        color: BRAND_PURPLE,
        fill: BRAND_PURPLE,
        border: '2px solid transparent',
        hover: {
            background: PRIMARY_BRAND_ORANGE,
        },
        focus: {
            background: PRIMARY_BRAND_ORANGE,
        },
        active: {
            background: '#bd3a20',
        },
    },
    'button-secondary': {
        background: TRANSPARENT,
        color: WHITE,
        fill: WHITE,
        border: '2px solid #FFFFFF',
        hover: {
            background: TRANSPARENT,
        },
        focus: {
            background: TRANSPARENT,
        },
        active: {
            background: TRANSPARENT,
        },
    },
};

export const styles: Record<VARIANTS, Record<ThemeTokens, any>> = {
    core_dark: defaultStyles,
    core_light: {
        background: {
            background: WHITE,
        },
        'overlay-gradient': {
            color: WHITE,
            background: WHITE,
        },
        ctaLink: {
            border: ACCESSIBLE_BRAND_ORANGE,
            color: BRAND_PURPLE,
        },
        'card-ctaLink': {
            border: ACCESSIBLE_BRAND_ORANGE,
            color: BRAND_PURPLE,
        },
        text: {
            color: BRAND_PURPLE,
            underline: ACCESSIBLE_BRAND_ORANGE,
        },
        'card-text': {
            color: BRAND_PURPLE,
            underline: ACCESSIBLE_BRAND_ORANGE,
        },
        card: {
            background: GRAY_UI_2000,
        },
        'button-primary': {
            background: ACCESSIBLE_BRAND_ORANGE,
            color: WHITE,
            fill: WHITE,
            border: '2px solid transparent',
            hover: {
                background: ACCESSIBLE_BRAND_ORANGE,
            },
            focus: {
                background: ACCESSIBLE_BRAND_ORANGE,
            },
            active: {
                background: ACCESSIBLE_BRAND_ORANGE,
            },
        },
        'button-secondary': {
            background: TRANSPARENT,
            color: BRAND_PURPLE,
            fill: BRAND_PURPLE,
            border: `2px solid ${BRAND_PURPLE}`,
            hover: {
                background: TRANSPARENT,
            },
            focus: {
                background: TRANSPARENT,
            },
            active: {
                background: TRANSPARENT,
            },
        },
    },
    core_gray: {
        background: {
            background: '#F8F7FA',
        },
        'overlay-gradient': {
            color: WHITE,
            background: '#F8F7FA',
        },
        ctaLink: {
            border: ACCESSIBLE_BRAND_ORANGE,
            color: BRAND_PURPLE,
        },
        'card-ctaLink': {
            border: ACCESSIBLE_BRAND_ORANGE,
            color: BRAND_PURPLE,
        },
        text: {
            color: BRAND_PURPLE,
            underline: ACCESSIBLE_BRAND_ORANGE,
        },
        'card-text': {
            color: BRAND_PURPLE,
            underline: ACCESSIBLE_BRAND_ORANGE,
        },
        card: {
            background: WHITE,
        },
        'button-primary': {
            background: ACCESSIBLE_BRAND_ORANGE,
            color: WHITE,
            fill: WHITE,
            border: '2px solid transparent',
            hover: {
                background: ACCESSIBLE_BRAND_ORANGE,
            },
            focus: {
                background: ACCESSIBLE_BRAND_ORANGE,
            },
            active: {
                background: ACCESSIBLE_BRAND_ORANGE,
            },
        },
        'button-secondary': {
            background: TRANSPARENT,
            color: BRAND_PURPLE,
            fill: BRAND_PURPLE,
            border: `2px solid ${BRAND_PURPLE}`,
            hover: {
                background: '#transparent',
            },
            focus: {
                background: '#transparent',
            },
            active: {
                background: '#transparent',
            },
        },
    },
    mood_01: defaultStyles,
    mood_02: defaultStyles,
    mood_03: defaultStyles,
};
